export const MULTIPLE_USERS_REMOVE_ORGANIZATION = '/account/users/bulk-remove-organization/';
